import { COMPONENT_IDS } from "../../helpers/constants/componentIds";
import { isNotEmpty } from "../../helpers/utils";
import { MuiBox } from "../box/MuiBox";
import { MuiButtonSecondary, MuiButtonPrimary } from "../button/MuiButton";
import { MuiFooterButtonsWrapper } from "./MuiFooterButtons.style";

interface MuiFooterButtonsProps {
  secondaryButtonLabel: string;
  primaryButtonLabel: string;
  onSecondaryClick?: () => void;
  onPrimaryClick?: () => void;
  hidePrimaryButton?: boolean;
}

export const MuiFooterButtons = ({
  secondaryButtonLabel,
  primaryButtonLabel,
  onSecondaryClick,
  onPrimaryClick,
  hidePrimaryButton = false,
}: MuiFooterButtonsProps) => {
  return (
    <MuiFooterButtonsWrapper>
      <MuiBox className="container-bottom">
        {isNotEmpty(secondaryButtonLabel) && (
          <MuiButtonSecondary
            id={COMPONENT_IDS.CANCEL_BUTTON}
            className="bottom-button-clear"
            onClick={onSecondaryClick}
          >
            {secondaryButtonLabel}
          </MuiButtonSecondary>
        )}

        {isNotEmpty(primaryButtonLabel) && !hidePrimaryButton && (
          <MuiButtonPrimary
            id={COMPONENT_IDS.UPDATE_BUTTON}
            className="bottom-button-continue"
            onClick={onPrimaryClick}
          >
            {primaryButtonLabel}
          </MuiButtonPrimary>
        )}
      </MuiBox>
    </MuiFooterButtonsWrapper>
  );
};
